import type * as LucideIcons from 'lucide-react';
import type { SVGProps } from 'react';
import { memo } from 'react';
import { cn } from '../../common/functions/cn';
import { useLoadIcon } from '../../common/hooks/use-load-icon';

export type OdinIconName = keyof typeof LucideIcons;

export interface OdinIconProps extends Omit<SVGProps<SVGSVGElement>, 'ref' | 'children'> {
  icon: OdinIconName;
  className?: string;
  /**
   * Stroke width for the icon (1-3 typical). Default is 2.
   */
  strokeWidth?: number;
}

const OdinIcon = memo(({ icon, className, strokeWidth = 2, ...props }: OdinIconProps) => {
  const Icon = useLoadIcon(icon);

  return <Icon strokeWidth={strokeWidth} className={cn('shrink-0', className)} color="currentColor" {...props} />;
});

OdinIcon.displayName = 'OdinIcon';
export default OdinIcon;
